import { useParams } from "react-router-dom";
import type { Product } from "../Home/Home";
import { Button } from "@mui/material";
import styles from "./Item.module.css";
import useAppState from "../../hooks/useAppState";
import { useEffect, useState } from "react";
import axios from "axios";
import Loading from "../../components/Loader/Loader";
import { AppConfig } from "../../utils/config";
import { cleanHtmlString } from "../../utils/constants";

export default function Item() {
  const { id } = useParams();
  const { shoppingCart, setShoppingCart } = useAppState();
  const [product, setProduct] = useState<Product>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${AppConfig.apiUrl}/products/${id}`)
      .then((res) => setProduct(res.data))
      .catch((err) => console.warn(err))
      .finally(() => setLoading(false));
  }, [id]);

  function addToBasket(data: Product) {
    setShoppingCart([
      ...shoppingCart,
      {
        ...data,
        ID: Number(id),
      },
    ]);
  }

  function removeFromBasket(data: Product) {
    const newCart = shoppingCart.filter((a) => a.ID !== Number(id));
    setShoppingCart(newCart);
  }

  function itemInCart(id: number) {
    return shoppingCart.some((a) => a.ID === id) || false;
  }

  if (!id) {
    return <div>No Item Selected</div>;
  }

  if (loading) {
    return (
      <div className={styles.inlineLoader}>
        <Loading />
      </div>
    );
  }

  if (!product) {
    return <div>No Item Found</div>;
  }

  return (
    <div className={styles.itemDetailedContainer}>
      <img src={`${AppConfig.lgImgUrl}/${id}.jpg`} alt={`${id} item`} />
      <div className={styles.itemDetails}>
        <div
          className={styles.itemTitle}
          dangerouslySetInnerHTML={{
            __html: cleanHtmlString(product.Title).replace(/\\r\\n/g, "\n"),
          }}
        />
        <div className={styles.itemReference}>
          Item Reference: {product.Reference}
        </div>
        {!itemInCart(Number(id)) ? (
          <Button variant="contained" onClick={() => addToBasket(product)}>
            £{product.Price} - Add to basket
          </Button>
        ) : (
          <Button variant="contained" onClick={() => removeFromBasket(product)}>
            £{product.Price} - Remove
          </Button>
        )}
      </div>
    </div>
  );
}
